<template>
    <div class="promoContent" id="homeHeroPromo1" >
        <div class="promoText">
            <h4>Share your Passion with Us!</h4>
            <h3>Investigator Initiated Research Opportunities</h3>
            <p>
                MIS is committed to extensive and sound research and documentation of product performance, 
                efficacy and safety.
            </p>
            <div class="btn">
                <a href="research-opportunities">
                    <span class="title">Learn More</span><i class="fal fa-chevron-right pl-s"></i>
                </a>
            </div>
        </div>
    </div>        
</template>

<script>
    export default {
        methods:{

        }
    }
</script>


<style>
    .promoContent
    {
        width: 100%;
        height: 70vh;
        text-align: center;
        display: flex;
        align-items: center;  
        background-color: #202020;
        color: #fff;
    }
    .promoContent span
    {
        margin: auto;
    }

    .promoText{
        color: #fff;
        width: 32vw;
        margin-left: 10vw;
        text-align: left;
    }
    .promoText h4{
        font-size: 22px;
        padding-bottom: 15px;
        color: #1894e2;
        font-weight: 400 !important;
    }
    .promoText h3{
        font-size: 48px !important;
        line-height: 48px !important;
        letter-spacing: -1px !important;
        padding-bottom: 5px;
        text-transform: uppercase;
    }
    .promoText p{
        padding-top: 20px;
        padding-bottom: 30px;
        font-size: 14px;
    }
    .promoText .btn
    {
        display: inline-block;
        border: solid 2px #fff;
        padding: 14px 25px;
        border-radius: 40px;
    }
</style>